function addManpackBasketItemToState(state, { employee, item, isAdd = true }) {
    let isNewEmployee = true;

    state.manpacks = state.manpacks.map(empl => {
        if (empl.employeeId == employee) {
            let isNewItem = true,
                indexRemove = null;

            empl.data = empl.data
                .filter((_item, index) => {
                    if (
                        _item.productId != item.removeId ||
                        item.removeId == item.productId
                    ) {
                        return true;
                    }

                    indexRemove = index;
                    return false;
                })
                .map(_item => {
                    if (_item.productId == item.productId) {
                        if (isAdd) {
                            item.qty = parseInt(item.qty) + parseInt(_item.qty);
                        } else {
                            item.qty = parseInt(item.qty);
                        }

                        _item = item;
                        isNewItem = isNewEmployee = false;
                    }

                    return _item;
                });

            if (isNewItem) {
                if (indexRemove !== null) {
                    empl.data.splice(indexRemove, 0, item);
                } else {
                    empl.data.push(item);
                }

                isNewEmployee = false;
            }
        }

        return empl;
    });

    if (isNewEmployee) {
        state.manpacks.push({
            employeeId: employee,
            data: [item]
        });
    }
}

export {
    addManpackBasketItemToState
}